import StyledBullet from './StyledBullet';
import BulletScreen from './BulletScreen';

export { StyledBullet };
export default BulletScreen;



// WEBPACK FOOTER //
// ./components/pipeline-interactMessage/relyon/index.js